


export class MaterialDataAniel {
  "materialNumber";
  "flagMaterialDeletion";
  "materialDescription";
  "baseUnitOfMeasure";
  "plant";
  "price";
  "controlCode";
  "dtImportacao";
  "id";
  constructor(data) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MaterialDataAniel`.
   */
  static getModelName() {
    return "MaterialDataAniel";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MaterialDataAniel for dynamic purposes.
  **/
  static factory(data) {
    return new MaterialDataAniel(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  static getModelDefinition() {
    return {
      name: 'MaterialDataAniel',
      plural: 'MaterialDataAniels',
      path: 'MaterialDataAniels',
      properties: {
        "materialNumber": {
          name: 'materialNumber',
          type: 'string'
        },
        "flagMaterialDeletion": {
          name: 'flagMaterialDeletion',
          type: 'string'
        },
        "materialDescription": {
          name: 'materialDescription',
          type: 'string'
        },
        "baseUnitOfMeasure": {
          name: 'baseUnitOfMeasure',
          type: 'string'
        },
        "plant": {
          name: 'plant',
          type: 'string'
        },
        "price": {
          name: 'price',
          type: 'number'
        },
        "controlCode": {
          name: 'controlCode',
          type: 'string'
        },
        "dtImportacao": {
          name: 'dtImportacao',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/MaterialDataAniel.js